<template>
  <section class="archive__result">
    <div class="position-relative tabs-results">
      <el-tabs v-model="selectedTab">
        <el-tab-pane name="cases" v-if="tabs.cases">
          <span slot="label"
            ><font-awesome-icon
              :icon="['fad', 'folder']"
              class="mr-2 product-icon"
            />{{ counts.cases }}
            {{ $t('knowledge.search-admin.collections') }}</span
          >
          <ArchivesViewerTabContent
            entity="cases"
            :details="results.cases"
            :count="counts.cases"
            @input="changePage($event, 'cases')"
            @focus-archive="focusArchive($event, 'cases')"
            @bulk-delete="bulkDelete($event, 'cases')"
            @launch-search="launchSearch($event, 'cases')"
          />
        </el-tab-pane>
        <el-tab-pane name="articles" v-if="tabs.articles">
          <span slot="label"
            ><img src="~assets/article_icon.svg" class="icon mr-2" />{{
              counts.articles
            }}
            {{ $t('knowledge.search-admin.articles') }}</span
          >
          <ArchivesViewerTabContent
            entity="articles"
            :details="results.articles"
            :count="counts.articles"
            @input="changePage($event, 'articles')"
            @focus-archive="focusArchive($event, 'articles')"
            @bulk-restore="$emit('bulk-restore', $event)"
            @bulk-delete="bulkDelete($event, 'articles')"
            @launch-search="launchSearch($event, 'articles')"
          />
        </el-tab-pane>
        <el-tab-pane name="diagnostics" v-if="tabs.diagnostics">
          <span slot="label"
            ><img src="~assets/diag_icon.svg" class="icon mr-2" />{{
              counts.diagnostics
            }}
            {{ $t('knowledge.search-admin.diagnostics') }}</span
          >
          <ArchivesViewerTabContent
            entity="diagnostics"
            :details="results.diagnostics"
            :count="counts.diagnostics"
            @input="changePage($event, 'diagnostics')"
            @focus-archive="focusArchive($event, 'diagnostics')"
            @bulk-restore="$emit('bulk-restore', $event)"
            @bulk-delete="bulkDelete($event, 'diagnostics')"
            @launch-search="launchSearch($event, 'diagnostics')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      v-if="results.length === 0"
      class="d-flex align-items-center justify-content-center"
    >
      <img src="~assets/empty-contents.svg" />
    </div>
  </section>
</template>

<script>
import ArchivesViewerTabContent from './ArchivesViewerTabContent';

export default {
  name: 'ArchivesViewerListSection',
  components: {
    ArchivesViewerTabContent,
  },
  props: {
    results: Object,
    counts: Object,
    tabs: {
      type: Object,
      default: () => {
        return {
          all: true,
          cases: false,
          articles: false,
          diagnostics: false,
          products: false,
        };
      },
    },
    moreOptions: Boolean,
  },
  data() {
    return {
      showActions: false,
      selectedContents: [],
      edit: {
        attributes: false,
        products: false,
      },
      selectedTab: Object.keys(this.tabs)[0],
      isManualSelection: false,
    };
  },
  methods: {
    // UTILS
    changePage(page, entity) {
      this.$emit('change-page', { page, entity });
    },
    focusArchive(entity, entityType) {
      this.$emit('focus-archive', { entity, entityType });
    },
    bulkDelete(entityIds, entityType) {
      this.$emit('bulk-delete', { entityIds, entityType });
    },
    launchSearch(search, entityType) {
      this.$emit('launch-search', { search, entityType });
    },
    selectTab() {
      return Object.keys(this.tabs).find((t) => this.tabs[t] === true);
    },
  },
  watch: {
    tabs() {
      this.selectedTab = this.selectTab();
    },
    selectedTab() {
      this.$emit('tab-change', this.selectedTab);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-results {
  :deep() .el-tabs__item {
    padding: 0px 10px;
  }
}
.tab-actions {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  cursor: pointer;
}
.active-bar {
  color: #409eff;
}
.icon {
  width: 16px;
  height: 16px;
}
</style>
